import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { createPinia } from 'pinia';

import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import Maska from 'maska';

import '@/assets/scss/config/modern/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import '@/assets/scss/components/custom.scss';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000,
});

createApp(App).use(createPinia()).use(router).use(BootstrapVueNext).use(Maska).use(LoadingPlugin).mount('#app');
